import React from 'react';
import styled from 'styled-components';
import { Container, Heading, Text } from '../primitives';
import { tokens } from '../../config/themeTokens';

const Wrapper = styled.section`
  padding: ${tokens.spacing.section} 0;
`;

export function IntroSection({ title, body, children }) {
  return (
    <Wrapper>
      <Container narrow>
        {title && <Heading level={2}>{title}</Heading>}
        {body && <Text>{body}</Text>}
        {children}
      </Container>
    </Wrapper>
  );
}

export default IntroSection;
